import { createColumnHelper } from "@tanstack/react-table";
import {
  escapeSearchQuery,
  compareNumericString,
  guestSentimentPaginatedPostRequestBody,
} from "../../../../shared";
import { starRatingConstants } from "../../../admin-screens/constants";
import {
  tableColumns,
  groupsExportHeaders,
  storesExportHeaders,
  buttonGroupConstant,
  brandProfileConstants,
  columnHeadersConstants,
  BRAND_PERFORMANCE_DISPLAY,
  performanceScreensConstants,
} from "../../constants";

const { SENTIMENT_CHANGE, TRANSACTION_CHANGE } = columnHeadersConstants;

// Share the same dates, ratings, search and sorting between the table and export.
export const buildBrandPerformanceRequestBody = ({
  pagination,
  pageNumber,
  size,
  sorting,
  sortBy,
  selectedOption,
  createDateFrom,
  createDateTo,
  searchString,
  selectedRatingOption,
  frRoute,
}) => {
  let filterQuery = `(SurveyCompletionDate > ${createDateFrom} and SurveyCompletionDate <= ${createDateTo})`;
  if (selectedOption.length) {
    const filters = selectedOption
      .map((option) => option.filter)
      .join(` ${brandProfileConstants.OR} `);
    filterQuery += ` ${brandProfileConstants.AND} (${filters})`;
  }
  const averageSentiments = {
    min: selectedOption.length
      ? selectedOption.map((option) => option.minStar)
      : [starRatingConstants.minStarRatingVal],
    max: selectedOption.length
      ? selectedOption.map((option) => option.maxStar)
      : [starRatingConstants.maxStarRatingVal],
  };
  return {
    ...guestSentimentPaginatedPostRequestBody({
      pagination,
      pageNumber,
      size,
      sortBy: sortBy || sorting,
      filterQuery,
      averageSentiments,
      isFrRoute: frRoute,
      isGuestSentimentFilter: selectedRatingOption === performanceScreensConstants.GUEST_SENTIMENTS,
    }),
    search: escapeSearchQuery(searchString),
  };
};

// Keep static column settings separate from report rendering.
export const createBrandPerformanceColumns = ({
  selectedResponse,
  cellNameRenderer,
  headerTransactionRatingRenderer,
  headerSentimentRatingRenderer,
  headerSurveyCompletionDateRenderer,
  cellTransactionChangeRenderer,
  cellSentimentChangeRenderer,
}) => {
  const columnHelper = createColumnHelper();
  return [
    columnHelper.accessor("name", {
      header: () => {
        return selectedResponse === buttonGroupConstant.STORE
          ? storesExportHeaders[0].label
          : groupsExportHeaders[0].label;
      },
      cell: cellNameRenderer,
    }),
    columnHelper.accessor("recordCount", {
      header: () => storesExportHeaders[1].label,
    }),
    columnHelper.accessor("transactionRating", {
      header: headerTransactionRatingRenderer,
    }),
    columnHelper.accessor("previousTransactionRating", {
      header: headerSurveyCompletionDateRenderer,
      minSize: tableColumns.SIZE_200,
      cell: (row) => row.getValue() || BRAND_PERFORMANCE_DISPLAY.MISSING_RATING,
    }),
    columnHelper.accessor("transactionChange", {
      header: () => TRANSACTION_CHANGE,
      enableSorting: true,
      cell: cellTransactionChangeRenderer,
      sortingFn: compareNumericString,
    }),
    columnHelper.accessor("sentimentRating", {
      header: headerSentimentRatingRenderer,
    }),
    columnHelper.accessor("previousSentimentRating", {
      header: headerSurveyCompletionDateRenderer,
      minSize: tableColumns.SIZE_200,
      cell: (row) => row.getValue() || BRAND_PERFORMANCE_DISPLAY.MISSING_RATING,
    }),
    columnHelper.accessor("sentimentChange", {
      header: () => SENTIMENT_CHANGE,
      enableSorting: true,
      cell: cellSentimentChangeRenderer,
      sortingFn: compareNumericString,
    }),
  ];
};
